import React, { useEffect, useState } from "react";
import brand from "../brand";
import ResultImagePanel from "../components/ResultImagePanel";
import { downloadResultPdf, fetchResultImage, getTodayIsoDate, shareResult } from "../utils/resultApi";

const TodayResult = () => {
  const [results, setResults] = useState({});
  const [loading, setLoading] = useState(true);
  const [notice, setNotice] = useState("");

  useEffect(() => {
    let active = true;

    const loadResults = async () => {
      try {
        const entries = await Promise.all(
          brand.drawTimes.map(async (draw) => [draw.key, await fetchResultImage(draw.key)])
        );
        if (active) {
          setResults(Object.fromEntries(entries));
        }
      } catch (error) {
        if (active) setNotice("Today's result feed could not be loaded.");
      } finally {
        if (active) setLoading(false);
      }
    };

    loadResults();
    const interval = window.setInterval(loadResults, 60000);
    return () => {
      active = false;
      window.clearInterval(interval);
    };
  }, []);

  const handleDownload = async (draw) => {
    try {
      await downloadResultPdf(results[draw.key], draw.key);
    } catch (error) {
      setNotice(error.message);
    }
  };

  const handleShare = async (draw) => {
    try {
      const result = await shareResult({
        title: `${brand.name} ${draw.label} Result`,
        text: `${brand.name} ${draw.label} result for ${getTodayIsoDate()}`,
      });
      setNotice(result === "copied" ? "Result link copied." : "Share panel opened.");
    } catch (error) {
      setNotice("Sharing is not available on this device.");
    }
  };

  return (
    <main className="page-shell">
      <section className="page-hero compact-hero">
        <span className="eyebrow">Today's results</span>
        <h1>{brand.name} Today Result</h1>
        <p>
          Both scheduled draw boards update automatically and stay optimized for
          mobile screens, PDF download, and quick sharing.
        </p>
      </section>

      {notice && <div className="toast-line">{notice}</div>}

      <section className="draw-grid">
        {brand.drawTimes.map((draw) => (
          <ResultImagePanel
            key={draw.key}
            title={`${brand.name} Result`}
            draw={draw}
            imageUrl={results[draw.key]}
            loading={loading}
            message={`${draw.label} result will be released soon.`}
            onDownload={() => handleDownload(draw)}
            onShare={() => handleShare(draw)}
          />
        ))}
      </section>
    </main>
  );
};

export default TodayResult;
